import { useQuery } from "@tanstack/react-query"
import { conversationQuery } from "../lib/conversationQuery"

export function useConversationQuery(...args: Parameters<typeof conversationQuery>) {
  return useQuery(conversationQuery(...args))
}
